// "há 3 minutos" / "3 minutes ago" no idioma da interface, sem depender de
// biblioteca de data (o dynamicTime do timeHelper fixa pt-BR).
const UNITS = [
  ['day', 24 * 60 * 60 * 1000],
  ['hour', 60 * 60 * 1000],
  ['minute', 60 * 1000],
  ['second', 1000],
];

const toIntlLocale = locale => String(locale || 'pt_BR').replace('_', '-');

export const formatRelativeTime = (date, { locale, now = Date.now() } = {}) => {
  const diffMs = Math.max(0, now - date.getTime());
  const [unit, size] = UNITS.find(([, ms]) => diffMs >= ms) || UNITS[3];
  const value = 0 - Math.floor(diffMs / size);
  let formatter;
  try {
    formatter = new Intl.RelativeTimeFormat(toIntlLocale(locale), {
      numeric: 'auto',
    });
  } catch {
    formatter = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });
  }
  return formatter.format(value, unit);
};
